import { render, staticRenderFns } from "./NavEntry.vue?vue&type=template&id=145bd4c2&"
import script from "./NavEntry.vue?vue&type=script&lang=js&"
export * from "./NavEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports